exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-51e22b6f] {\n  list-style-type: disc;\n  padding-left: 22px;\n  color: #085FCE;\n}\nul li p[data-v-51e22b6f] {\n  margin-bottom: 0;\n}", ""]);

// exports
